import { MapAbTestsArgs } from './abTests.types'

import { TestGroup } from 'types'
import { report } from 'utils/logging/logging'

export const overrideAbTests = <T extends string>(
  initialAbTests: { [key in T]: TestGroup },
  defaultAbTestKeys: T[],
  abTestOverrides: Partial<{ [key in string]: TestGroup }>,
) => {
  return defaultAbTestKeys.reduce(
    (accumulator, key) => {
      const overrideValue = abTestOverrides[key]

      const shouldOverrideValue = overrideValue !== undefined

      accumulator[key] = shouldOverrideValue ? overrideValue : initialAbTests[key]

      return accumulator
    },
    {} as Record<T, TestGroup>,
  )
}

export const mapAbTests = <T extends string>({
  abTestsData,
  defaultAbTests,
  isSuccess,
}: MapAbTestsArgs<T>) => {
  const abTestKeys = Object.keys(defaultAbTests) as T[]

  const abTests: Record<T, TestGroup> =
    isSuccess && abTestsData
      ? abTestKeys.reduce(
          (accumulator: Record<T, TestGroup>, key) => {
            const testEntry = abTestsData.find((test) => test.testName === key)
            accumulator[key] =
              testEntry && testEntry.testGroup ? testEntry.testGroup : defaultAbTests[key]
            return accumulator
          },
          {} as Record<T, TestGroup>,
        )
      : { ...defaultAbTests }

  return abTests
}

export const createPostQuoteAbTestKeys = ({
  dateOfBirth,
  postalCode,
  firstQuoteId,
}: {
  dateOfBirth: string | undefined
  postalCode: string | undefined | null
  firstQuoteId: string | undefined
}) => {
  if (!dateOfBirth || !postalCode || !firstQuoteId || !postalCode?.trim()) {
    report(new Error(), 'createPostQuoteAbTestKeys - Could not create postQuoteKey', {
      args: {
        dateOfBirth,
        postalCode,
        firstQuoteId,
      },
    })
    return undefined
  }

  const sanitizedPostalCode = postalCode.replace(/\s+/g, '')

  return {
    userKey: `${dateOfBirth}_${sanitizedPostalCode}`,
    participantId: firstQuoteId,
  }
}
